var handle_array = ["macrocarpa-slab","recycled-native-ex-demolition","recycled-native-timber-for-re-use"];
 var hide_price=1;
 var hide_ajaxaddtocart =1;
 var display_phone = 1;
 var phone_no='021 744 970';
 var display_call_for_price=1;
 var call_for_price_label = 'Email us for Price';
 var css_style_button='background-color: #000000;color:#ffffff;';
 var enabled_captcha = 1;
 var site_key = '6LfQe9AUAAAAALhOi95ebdTcDSgkcxicOYH9U7I7';
 var thankyou_msg = 'We\'ve received your message and will be in touch as soon as possible.';
 var thankyou_header = 'Thank you';
 var name_label='Name';
 var email_label='Email';
 var phone_label = ' Phone Number';
 var comment_label = 'Comment';
 var submit_label ='Submit';
 var error_name_label='Please fill out this field.';
 var error_email_label='Please fill out this field.';
 var error_phone_label = 'Please fill out this field.';
 var error_comment_label = 'Please fill out this field.';
 var enable_app =1;
 var enable_outofstock = 1;
 var price_selector='';
 var cart_selector='#AddToCart-product-template';
 var phone_no_label = 'Call us for Price:';
 var required_field='name,email,comment';
 var contact_form_heading='Contact us regarding';
 var parent_selector='';
 var unavailable_label='Unavailable';
